import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { ThemeService } from 'src/app/services/theme/theme.service';
import { ProductOverviewComponent } from '../default/product-overview.component';
import { OnlineProductOverviewComponent } from '../online/online-product-overview.component';

@Component({
  selector: 'app-product-overview-wrapper',
  styleUrls: ['./product-overview-wrapper.component.scss'],
  templateUrl: './product-overview-wrapper.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ProductOverviewComponent, OnlineProductOverviewComponent],
})
export class ProductOverviewWrapperComponent implements OnInit {
  private themeService = inject(ThemeService);

  isOnline: boolean;

  ngOnInit() {
    this.isOnline = this.themeService.isOnline;
  }
}
